/** Search all products against:
 *
 * Product title
 * Product handle
 * Product description (body_html / storefront description)
 * Product type
 * Vendor
 * Tags
 * Variant title
 *
 **/

import { LIGHT_PRODUCT_LIST_FIELDS } from './fragments/productFields';

const searchProductsQuery = `
  query searchProducts($query: String!, $first: Int = 20, $after: String, $country: CountryCode) @inContext(country: $country) {
    products(first: $first, after: $after, query: $query) {
      pageInfo { hasNextPage hasPreviousPage startCursor endCursor }
      edges {
        cursor
        node {
          ${LIGHT_PRODUCT_LIST_FIELDS({
              warningKey: 'productWarning',
              variantShape: 'edges',
              variantFirst: 20,
              imageCount: 50,
              includeCollections: true,
          })}
        }
      }
    }
  }
`;

export default searchProductsQuery;
